import { getDomain } from './getDomain'

/**
 * @param {string} path
 */
export function forwardTo(path) {
  window.location.href = getDomain() + path
}
